export default {
  color: ["rgba(76, 145, 246, 1)", "rgba(82, 204, 197, 1)"],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  legend: {
    show: false,
  },
  grid: {
    top: "5%",
    left: "3%",
    right: "4%",
    bottom: "3%",
    containLabel: true,
  },
  xAxis: {
    type: "category",
    data: [],
  },
  yAxis: {
    type: "value",
    splitLine: {
      lineStyle: {
        type: "dashed",
        color: "rgba(255,255,255, .2)",
      },
    },
  },
  series: [
    {
      name: "2012",
      type: "bar",
      data: [],
      barWidth: 22,
      itemStyle: {
        borderRadius: [3, 3, 0, 0],
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#3870D4",
            },
            {
              offset: 1,
              color: "rgba(56,112,212,0.5)",
            },
          ],
        },
      },
    },
  ],
  graphic: [{}],
}
